import React, { useState, useEffect } from "react";
import { Dialog, DialogActions } from "@mui/material";
import axiosClient from "../../service/axios";
import { customerToast } from "../NotificationToast";
import InitiatedDetails from "./InitiatedDetails";
import QuipStock from "./QuipStock";

function Initiation({
  initiation,
  setInitiation,
  openReturn,
  orderDetails,
  ...props
}) {
  const [data, setData] = useState([]);
  const [request, setRequest] = useState([]);
  const [details, setDetails] = useState(false);
  const [checker, setChecker] = useState(false);
  const [list, setList] = useState([]);

  const handleModalClose = () => {
    setInitiation(false);
  };

  const whichModalToOpen = () => {
    if (orderDetails.title === "stockbank" || orderDetails.title === "Quip") {
      setChecker(true);
      handleModalClose();
    } else {
      openReturn();
    }
  };

  const initiateCustomer = async () => {
    try {
      const response = await axiosClient.post(
        "/lite/v2/api/v3/customer/return",
        orderDetails
      );
      if (
        (response.data.status === 200) &
        (response.data.message === "No Request to return")
      ) {
        customerToast();
        setInitiation(false);
      } else if (
        (response.data.status === 200) &
        (response.data.message === "Request Return List")
      ) {
        setData(response.data.products);
        setRequest(response.data.request);
        setDetails(true);
        setInitiation(false);
      } else {
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };
  console.log(orderDetails);
  useEffect(() => {
    const getList = async () => {
      try {
        const response = await axiosClient.get(
          `/lite/v2/api/v3/return-item/list/${orderDetails?.title}/${orderDetails?.order_id}`
        );
        if (response.status === 200) {
          setList(response.data.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (orderDetails.title) {
      getList();
    }
  }, [orderDetails]);

  // console.log(list);

  return (
    <>
      <Dialog open={initiation} onClose={handleModalClose}>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "50px",
          }}
        >
          <div
            style={{
              cursor: "pointer",
              color: "#253858",
              backgroundColor: "#DFE1E6",
              padding: "10px",
              borderRadius: "3px",
              border: "1px solid #DFE1E6",
              fontSize: "14px",
            }}
            onClick={initiateCustomer}
          >
            Customer Initiated
          </div>
          <div
            style={{
              cursor: "pointer",
              color: "#ffffff",
              backgroundColor: "#b70303",
              padding: "10px",
              borderRadius: "3px",
              border: "1px solid #DFE1E6",
              fontSize: "14px",
            }}
            onClick={whichModalToOpen}
          >
            CSA Initiated
          </div>
        </DialogActions>
      </Dialog>

      <InitiatedDetails
        details={details}
        setDetails={setDetails}
        request={request}
        customerData={list}
        data={data}
      />

      <QuipStock
        checker={checker}
        setChecker={setChecker}
        data={list}
        values={props}
      />
    </>
  );
}

export default Initiation;
